import React from 'react'
import { useFormContext } from 'react-hook-form'

import BottomRightWidget from './BottomRightWidget.svg'
import BottomLeftWidget from './BottomLeftWidget.svg'
import CenterRightWidget from './CenterRightWidget.svg'
import CenterLeftWidget from './CenterLeftWidget.svg'
import { BADGE_POSITION_VALUE } from 'Src/constants'

const previewComponentMap = {
  [BADGE_POSITION_VALUE.BOTTOM_RIGHT]: BottomRightWidget,
  [BADGE_POSITION_VALUE.BOTTOM_LEFT]: BottomLeftWidget,
  [BADGE_POSITION_VALUE.CENTER_RIGHT]: CenterRightWidget,
  [BADGE_POSITION_VALUE.CENTER_LEFT]: CenterLeftWidget
}

const WidgetPreviewMiniMap = () => {
  const { watch } = useFormContext()

  const badgePosition = watch('badgePosition')
  const brandColor = watch('brandColor')

  const PreviewComponent = previewComponentMap[badgePosition] || BottomRightWidget

  return (
    <div style={{ color: brandColor }}>
      <PreviewComponent width='160px' />
    </div>
  )
}

export default WidgetPreviewMiniMap
